import { render, staticRenderFns } from "./CustomTextarea.vue?vue&type=template&id=39bd654c&scoped=true&lang=pug"
import script from "./CustomTextarea.vue?vue&type=script&lang=js"
export * from "./CustomTextarea.vue?vue&type=script&lang=js"
import style0 from "./CustomTextarea.vue?vue&type=style&index=0&id=39bd654c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd654c",
  null
  
)

export default component.exports